"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EventDescription = void 0;
const Description_1 = require("./Description");
const EventDto_1 = require("../dto/EventDto");
const EventSettings_1 = require("./EventSettings");
class EventDescription {
    constructor(settings, description) {
        this.id = 0;
        this.code = "";
        this.uuid = "";
        this.state = EventDto_1.EventState.DRAFT;
        this.visibility = EventDto_1.EventVisibility.PUBLIC;
        this.created = 0;
        this.updated = 0;
        this.settings = settings;
        this.description = description;
    }
    static fromDto(eventDescriptionDto) {
        const description = Description_1.Description.fromDto(eventDescriptionDto.description);
        const settings = eventDescriptionDto.settings
            ? EventSettings_1.EventSettings.fromDto(eventDescriptionDto.settings)
            : EventSettings_1.EventSettings.DEFAULT;
        const result = new EventDescription(settings, description);
        result.id = eventDescriptionDto.id;
        if (eventDescriptionDto.code) {
            result.code = eventDescriptionDto.code;
        }
        result.uuid = eventDescriptionDto.uuid;
        result.state = eventDescriptionDto.state;
        result.visibility = eventDescriptionDto.visibility;
        result.created = eventDescriptionDto.created;
        result.updated = eventDescriptionDto.updated;
        return result;
    }
    toDto() {
        return {
            id: this.id,
            code: this.code,
            uuid: this.uuid,
            state: this.state,
            visibility: this.visibility,
            created: this.created,
            updated: this.updated,
            settings: this.settings,
            description: this.description.toDto()
        };
    }
}
exports.EventDescription = EventDescription;
